// extracted by mini-css-extract-plugin
export default {"root":"vjuxndAcQsbpHgQ2FhbW","rootContent":"Y8_6P0wfKGxw2hmOnj8P","title":"tWiOnJLFcoVmANTTXVlV","content":"fhEpWfIzzdhscnn0iecD","partnerLink":"TPdBTcN1WuNoQxsFb4tY"};